// extracted by mini-css-extract-plugin
export default {"profile_info_title":"ProfileInfo_profile_info_title__-VD3b","profile_info":"ProfileInfo_profile_info__2HCZJ","profile_img":"ProfileInfo_profile_img__Vx2vL"};